import { cn } from "@/lib/utils";
import { product } from "@/lib/branding";

export function PageHeader({ title, subtitle, actions, className, testid }) {
    return (
        <header
            data-testid={testid || "page-header"}
            className={cn(
                "flex items-end justify-between gap-4 px-8 pt-8 pb-6 border-b border-border",
                className
            )}
        >
            <div>
                <div className="overline mb-2">{product()}</div>
                <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tighter leading-none">
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </header>
    );
}
